import { useEffect } from "react";

export const useDisableBodyScroll = (disable: boolean) => {
  useEffect(() => {
    document.body.classList.toggle("overflow-hidden", disable);
  }, [disable]);

  return null;
};
